import EventManager from '../../eventManager/EventManager'
import { writeCss } from '../../helpers/DOM'
import { doOnce } from '../../helpers/doOnce'
import { Slot } from '../Slot'

export const hideClass = `mv-hidden`
export const fallbackTimeout = 5000

interface IConfig {
  height: string
  width: string
}

const defaultConfig = {
  height: '264px',
  width: '300px'
}

/**
 * Protects against CLS creep during refreshes
 * by hiding the content inside a slot's wrapper/adBox
 * during refresh and re-displaying it after all resizing
 * events have occurred.
 */
export const hasClsToggle = (config: IConfig = defaultConfig) => (
  target: Constructor<Slot>
): any =>
  class extends target {
    get container(): HTMLElement | null {
      return (
        document.querySelector(`[data-slotid="${this.id}"]`) || this.wrapper
      )
    }

    template() {
      writeStyles()
      EventManager.on(EventManager.events.slotRefreshed, (slot) => {
        if (slot === this) {
          this.hide()
        }
      })

      return super.template()
    }

    sizeContainers() {
      this.hide()
      super.sizeContainers()
      /** Ensure wrapper stays static in dimensions */
      if (this.container) {
        this.container.style.height = `${config.height}`
        this.container.style.width = `${config.width}`
      }

      this.show()
    }

    private hide({ container, show } = this) {
      container?.classList.add(hideClass)
      /**
       * Reveal slot after fallback time elapses
       */
      setTimeout(show, fallbackTimeout)
    }

    private show({ container } = this) {
      container?.classList.remove(hideClass)
    }
  }

const writeStyles = doOnce(() => {
  writeCss(getStyles())
})

const getStyles = () => `
  .${hideClass} > div {
    display: none!important;
  }
`
